// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.select_type_pzgmfx {\r\n  background-color: #012032 !important;\n}\n.select_type_pzgmfx .el-select-dropdown__item {\r\n  color: #00d0e8 !important;\n}\n.select_type_pzgmfx .el-select-dropdown__item.selected {\r\n  color: rgb(252, 216, 52) !important;\n}\n.select_type_pzgmfx .el-select-dropdown__item.hover,\r\n.select_type_pzgmfx .el-select-dropdown__item:hover {\r\n  background-color: #0f7399 !important;\n}\r\n", ""]);
// Exports
module.exports = exports;
